import React from 'react'
import moment from 'moment'
import { Button } from 'antd'
import { WhiteTable } from 'Common/styled'

import { agreementTableLocale } from 'Common/constants'
import { getAgreementStateLabel, getPurposeStateLabel } from 'Common/utils'
import * as _ from 'lodash'
import { userType } from '../../common/constants'

const AgreementTable = props => {
  const sortDirection = key => {
    // If column is sorted pass direction
    return props.sort.key === key ? props.sort.direction : undefined
  }

  const getStateLabel = agreement => {
    if (agreement.asProposal) {
      return getPurposeStateLabel(agreement.proposalState)
    } else {
      return getAgreementStateLabel(agreement.agreementState)
    }
  }

  const columns = [
    {
      title: 'Num.',
      dataIndex: 'agreementId',
      key: 'agreementId',
      sorter: true,
      defaultSortOrder: sortDirection('agreementId')
    },
    {
      title: 'Titolo',
      dataIndex: 'title',
      key: 'title',
      sorter: true,
      defaultSortOrder: sortDirection('title')
    },
    {
      title: 'Creato da',
      dataIndex: 'userName',
      key: 'userName',
      render: (value, record) => {
        const styleSmall = {
          display: 'block',
          textTransform: 'uppercase'
        }

        return (
          <span>
            {_.get(record, 'userFirstName', '') +
              ' ' +
              _.get(record, 'userLastName', '')}
            <small style={styleSmall}>
              {_.get(
                _.find(userType, { key: _.get(record, 'userType', null) }),
                'label',
                ''
              )}{' '}
            </small>
          </span>
        )
      }
    },
    {
      title: 'Fornitore',
      dataIndex: 'destSupplier',
      key: 'destSupplier',
      sorter: true,
      defaultSortOrder: sortDirection('destSupplier')
    },
    {
      title: 'Stato',
      render: record => getStateLabel(record),
      key: 'agreementState',
      sorter: true,
      defaultSortOrder: sortDirection('agreementState')
    },
    {
      title: 'Valido dal',
      render: record => moment(record.validFrom).format('DD-MM-YYYY'),
      key: 'validFrom',
      sorter: true,
      defaultSortOrder: sortDirection('validFrom')
    },
    {
      title: 'Valido al',
      render: record => moment(record.validTo).format('DD-MM-YYYY'),
      key: 'validTo',
      sorter: true,
      defaultSortOrder: sortDirection('validTo')
    },
    {
      key: 'actions',
      render: record => (
        <Button
          // Button is loading while agreement is fetched
          loading={
            props.loading.loading && record.agreementId === props.loading.id
          }
          icon="eye"
          type="primary"
          title="Visualizza"
          onClick={() => props.viewAgreementCallback(record.agreementId, props.tab)}
        />
      )
    }
  ]
  return (
    <WhiteTable
      locale={agreementTableLocale}
      columns={columns}
      dataSource={props.agreementsList}
      pagination={props.pagination}
      rowKey={record => record.agreementId}
      onChange={props.onChangeCallback}
    />
  )
}
export default AgreementTable



// WEBPACK FOOTER //
// ./src/components/AgreementTable/index.js